export const init = () => {
  const passwords = cube.$$('.js-password');


  passwords.forEach(password => {
    const formGroup = password.$('.form-group');
    const input = password.$('input[name="password"]');
    const rules = password.$('.password-strengh-list');

    if (formGroup.classList.contains('displayable-password')) {
      const icon = password.$('.displayable-password__icon');

      icon.on('click', () => showPassword(icon, input));
    }

    if (rules)
      password.on('input', () => validatePasswordStrengh(rules, input));
  });
};


/**
 * Show or Hide the password input content.
 *
 * @param {HTMLElement} icon The eye icon.
 * @param {HTMLInputElement} input The password input.
 */
const showPassword = (icon, input) => {
  if (input.type === 'password') {
    input.type = 'text';
    icon.classList.add('displayable-password__icon--activated');
  }
  else {
    input.type = 'password';
    icon.classList.remove('displayable-password__icon--activated');
  }
};


/**
 *
 * @param {HTMLElement} rules The list of rules.
 * @param {HTMLInputElement} input The password input.
 */
const validatePasswordStrengh = (rules, input) => {
  const { regex } = input.dataset;

  if (!regex)
    return;

  Object.entries(JSON.parse(regex)).forEach(([key, value]) => {
    const rule = rules.$(`.${ key }`);
    const validator = new RegExp(value);

    if (validator.test(input.value))
      rule.classList.add('passed');
    else
      rule.classList.remove('passed');
  });
};


export const rules = {
  rules: {
    password: {
      passwordCheck: true
    }
  }
};


// WEBPACK FOOTER //
// ./src/customer/customer-password.js